<app-navbar-style-two></app-navbar-style-two>
<div style="margin-top: 100px;" class="ptb-100">
    <div class="container questions-width">
        <h1 class="headline">What's the property address?</h1>
        <div class="row">
            <form> 
                <input                        
                       class="form-control haus-form-control"
                       type="text" 
                       placeholder="Address Line 1"
                       [(ngModel)]="this.hubspot.QuestionPropertyStreetAddress" 
                       [ngModelOptions]="{standalone: true}" 
                       maxlength="25" 
                       required >
            </form>
        </div>
        <div class="row">
            <form class="multiple-box"> 
                <input                        
                       class="form-control haus-form-control"
                       type="text" 
                       placeholder="City"
                       [(ngModel)]="this.hubspot.QuestionPropertyCity" 
                       [ngModelOptions]="{standalone: true}" 
                       maxlength="10" 
                       required >
                <input                        
                       class="form-control haus-form-control"
                       type="text" 
                       placeholder="State"
                       [(ngModel)]="this.hubspot.QuestionPropertyState" 
                       [ngModelOptions]="{standalone: true}" 
                       maxlength="2" 
                       required >
            </form>
        </div>
        <div class="row">
            <form> 
                <input                        
                       class="form-control haus-form-control"
                       type="text" 
                       placeholder="Zip"
                       [(ngModel)]="this.hubspot.QuestionPropertyZip" 
                       [ngModelOptions]="{standalone: true}" 
                       maxlength="5" 
                       required >
            </form>
        </div>
        <h5 class="haus-answer-h5" *ngIf="this.hubspot.QuestionPropertyStreetAddress">Property: 
            {{ this.hubspot.QuestionPropertyStreetAddress }} 
            {{ this.hubspot.QuestionPropertyCity }} 
            {{ this.hubspot.QuestionPropertyState }}
            {{ this.hubspot.QuestionPropertyZip }}
        </h5>
        <a class="haus-btn" *ngIf="this.hubspot.QuestionPropertyZip" routerLink="/subject-property-type">
            <h1>Next</h1>
        </a>
        <h5 class="haus-h5" *ngIf="this.hubspot.QuestionPropertyZip" routerLink="/whats-your-name">Go Back
        </h5>
    </div>
</div>
<app-main-just-funded></app-main-just-funded>
<app-footer-style-five></app-footer-style-five>